import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.filter.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.iterator.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.map.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.to-string.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.set.constructor.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.string.iterator.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/web.dom-collections.iterator.js';
import { __spreadArray } from '../node_modules/.pnpm/node_modules/tslib/tslib.es6.js';
import React from 'react';
import { Grid } from 'antd-mobile';
import { isArray, isFunction } from 'lodash';
import classNames from 'classnames';
import SelectorItem from './Item/index.js';
import './style/index.less.js';

var Selector = function Selector(props) {
  var value = props.value,
    onChange = props.onChange,
    _a = props.selectType,
    selectType = _a === void 0 ? 'single' : _a,
    _b = props.disabled,
    disabled = _b === void 0 ? false : _b,
    _c = props.options,
    options = _c === void 0 ? [] : _c,
    _d = props.columns,
    columns = _d === void 0 ? 2 : _d,
    className = props.className,
    style = props.style;
  var handleChange = function handleChange(v) {
    if (!isFunction(onChange)) {
      return;
    }
    onChange(v);
  };
  var handleItemClick = function handleItemClick(selectedOption, active) {
    if (disabled) {
      return;
    }
    if (active) {
      if (selectType === 'single') {
        handleChange(selectedOption.value);
      } else {
        var incre = isArray(value) ? value : [];
        onChange(__spreadArray(__spreadArray([], incre, true), [selectedOption.value], false));
      }
    } else {
      if (selectType === 'single') {
        handleChange(null);
      } else {
        var unActiveKeys = (isArray(value) ? __spreadArray([], value, true) : []).filter(function (x) {
          return x !== selectedOption.value;
        });
        onChange(unActiveKeys);
      }
    }
  };
  var items = options.map(function (x) {
    var _active = false;
    if (selectType === 'single') {
      _active = x.value === value;
    } else {
      var set = new Set(isArray(value) ? __spreadArray([], value, true) : []);
      _active = set.has(x.value);
    }
    var _disabled = disabled || (x === null || x === void 0 ? void 0 : x.disabled);
    return /*#__PURE__*/React.createElement(SelectorItem, {
      key: x.value,
      active: _active,
      option: x,
      disabled: _disabled,
      onItemClick: handleItemClick
    });
  });
  var mergeCls = classNames('ti-selector', className);
  return /*#__PURE__*/React.createElement("div", {
    className: mergeCls,
    style: style
  }, /*#__PURE__*/React.createElement(Grid, {
    columns: columns
  }, items));
};

export { Selector as default };
